var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLeftmenuIcon05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1321_2501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1667 34.6667C24.4973 34.6667 24.7743 34.5549 24.998 34.3313C25.2216 34.1077 25.3334 33.8306 25.3334 33.5001C25.3334 33.1695 25.2216 32.8924 24.998 32.6688C24.7743 32.4452 24.4973 32.3334 24.1667 32.3334C23.8362 32.3334 23.5591 32.4452 23.3355 32.6688C23.1118 32.8924 23 33.1695 23 33.5001C23 33.8306 23.1118 34.1077 23.3355 34.3313C23.5591 34.5549 23.8362 34.6667 24.1667 34.6667ZM23 31.1667H25.3334V25.3334H23V31.1667ZM27.6667 33.5001H37V31.1667H27.6667V33.5001ZM27.6667 28.8334H37V26.5001H27.6667V28.8334ZM18.3334 39.3334V20.6667H41.6667V39.3334H18.3334ZM20.6667 37.0001H39.3334V23.0001H20.6667V37.0001Z",
    fill: "#95A1C6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1321_2501"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftmenuIcon05);
export default __webpack_public_path__ + "static/media/leftmenu_icon05.291c4397d14964120ee3dc8c9c7ee8a2.svg";
export { ForwardRef as ReactComponent };